var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order.deliverect_status
    ? _c("div", { staticClass: "orderList--status--pills my-10" }, [
        _c(
          "div",
          {
            staticClass: "pill text-white bg-bo-s2",
            attrs: {
              title:
                "Statut Deliverect: " + _vm.order.deliverect_status.LastReason,
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.displayDeliverectStatus(
                    _vm.order.deliverect_status.lastStatus
                  )
                ) +
                "\n    "
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }